import { colorPalette } from '../../colorPalette';
import { styled } from '@mui/system';
export const ratingStyle = {
    background: 'none',
    gap: '4px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    width: 'fit-content',
};
export const RatingText = styled('div')(({ rating }) => ({
    fontStyle: 'normal',
    fontWeight: rating.size === 'sm' ? 400 : 600,
    fontSize: rating.size === 'sm' ? '14px' : '18px',
    color: rating.size === 'sm' ? colorPalette.gray700 : colorPalette.gray1000,
}));
export const starIcon = {
    fontSize: '14px',
    color: `${colorPalette.yellow500}`,
};
export const emptyStarIcon = {
    opacity: 1,
    color: colorPalette.gray300,
};
